export const appRoutes = {
  snackBio: '/link',
  boba: '/boba',
}
